/*
 * @Date: 2019-08-22 10:23:31
 * @LastEditors: x
 * @LastEditTime: 2019-09-06 12:14:01
 */
import * as types from '../mutation-types'

const state = {
  isDialogFromLogin: false,
  registerParams: {}, // 注冊參數
}

const mutations = {
  [types.SET_IS_DIALOG_FROM_LOGIN](state, val) {
    state.isDialogFromLogin = val
    localStorage.setItem('isDialogFromLogin', val ? 1 : 0)
  },
  [types.SET_Register_Params] (state, val) {
    state.registerParams = val
  }
}

export default {
  state,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/base.js